import React from 'react';
import { Input, Form } from 'antd';
import styled from 'styled-components';
import { textInputValueWithoutEmoji } from '_src/utils';

const Label = styled.label`
  margin-bottom: ${({ inline }) => (inline ? '0' : '5px')};
  margin-right: ${({ inline }) => (inline ? '5px' : '0')};
  min-width: ${({ inline }) => (inline ? '30%' : '0')};
  color: ${({ hasError }) => (hasError ? '#f5222d' : '')};
`;

const Container = styled.div`
  display: ${({ inline }) => (inline ? 'flex' : 'block')};
  align-items: center;
`;

export default ({
  value = '',
  error,
  onChange,
  onBlur = {},
  touched,
  label,
  inline = false,
  dataCy = '',
  name = '',
  placeholder = '',
  maskValue = false,
  ...rest
}) => {
  const hasError = error && touched;
  const inputId = rest.id || name || undefined;

  return (
    <Form.Item validateStatus={hasError ? 'error' : ''}>
      <Container inline={inline}>
        {(label || hasError) && (
          <Label htmlFor={inputId} inline={inline} hasError={hasError}>
            {hasError ? error : label}
          </Label>
        )}
        <Input
          {...rest}
          id={inputId}
          name={name}
          aria-label={label || placeholder || name || undefined}
          aria-invalid={Boolean(hasError)}
          value={maskValue ? '********' : value}
          data-cy={dataCy || 'field-input-' + name}
          placeholder={label || placeholder}
          onChange={e => onChange(textInputValueWithoutEmoji(e.target.value))}
          onBlur={e => {
            if (typeof onBlur === 'function') {
              onBlur(e.target.value);
            }
          }}
        />
      </Container>
    </Form.Item>
  );
};
